import {useEffect, useState, useRef} from "react";
import {useTranslation} from "react-i18next";
// -
import {QT2GServerValuesModel, QT2GServerHasModel} from "./models/QT2GModels";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import RowTRComponent from "../../../components/RowTRComponent";

const QT2GForm = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...QT2GServerValuesModel});
    const [has, setHas] = useState({...QT2GServerHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            if (item.values) {
                setValues({...item.values});
                setHas({...item.has});
            } else {
                setValues({...QT2GServerValuesModel});
                setHas({...QT2GServerHasModel});
            }
        } else {
            setValues({...QT2GServerValuesModel});
            setHas({...QT2GServerHasModel});
        }
    }, [item]);

    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <RowTRComponent
                        fieldName="pin"
                        _TC={_TC}
                        valueIn={values.pin}
                        hasIn={has.has_pin}
                        deactivated={QT2GServerValuesModel.pin}
                        styleCenterMiddle={styleCenterMiddle}
                        inputProps={{
                            maxLength: "4",
                            "data-default": "0000"
                        }}
                    />
                    <RowTRComponent
                        fieldName={"apn_name"}
                        _TC={_TC}
                        valueIn={values.apn_name}
                        hasIn={has.has_apn_name}
                        deactivated={QT2GServerValuesModel.apn_name}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"apn_user"}
                        _TC={_TC}
                        valueIn={values.apn_user}
                        hasIn={has.has_apn_user}
                        deactivated={QT2GServerValuesModel.apn_user}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"apn_pass"}
                        _TC={_TC}
                        valueIn={values.apn_pass}
                        hasIn={has.has_apn_pass}
                        deactivated={QT2GServerValuesModel.apn_pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>

            </div>
        </div>
    )
}
export default QT2GForm